import { oneOf, roleGuard } from './role-guard.util';

export const hrGuard = roleGuard(oneOf('FRACTAL_HR', 'CLIENT_HR'), '/admin/sign-in');
